export const CAL_LIST_BLOCK_FETCH = 'calListBlock/CAL_LIST_BLOCK_FETCH';
export const CAL_LIST_BLOCK_FETCHED = 'calListBlock/CAL_LIST_BLOCK_FETCHED';
export const CAL_LIST_BLOCK_ERROR = 'calListBlock/CAL_LIST_BLOCK_ERROR';
export const CAL_LIST_BLOCK_CHANGE_SELECTED_PAGE_ID =
  'calListBlock/CAL_LIST_BLOCK_CHANGE_CURRENT_PAGE_ID';
export const CAL_LIST_BLOCK_LAST_SEARCHED_CATEGORY =
  'calListBlock/CAL_LIST_BLOCK_LAST_SEARCHED_CATEGORY';
